/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Full Screen Enter Icon component.
 */
const SystemFullScreenEnterIcon = ({
  size = IconSize.medium,
  color = dlsColor('grey1')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M20.16 4.54597L13.5681 11.1819M15.0682 4.5459L20.16 4.54597V9.68202M4.54597 20.16L11.1819 13.5681M4.5459 15.0682L4.54597 20.16H9.68202' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(SystemFullScreenEnterIcon);
